export default "__VITE_ASSET__d2d93727__"